import { css as o } from "lit";
const r = o`nav{background-color:var(--header-nav_background-color)}.nav-row{border-top:var(--header-nav_border-top)}@media all and (max-width:1024px){:host(:not([unresponsive])) nav{background-color:var(--header-nav-mobile_background-color)}}`;
export { r as stylesBase };